import React, { useMemo } from "react";
import Header from "../homepage/components/Header";
import Footer from "../homepage/components/Footer";
import Seo from "../../components/Seo";
import manifest from "../../data/portfolioManifest.json";
import { BookCoverCarousel } from "./components/BookCoverCarousel";

const BookCoverDesignPage = () => {
  const coverItems = useMemo(() => {
    const raw = manifest.bookCoverDesign ?? [];
    return raw.map((it) => ({
      name: it.name,
      src: it.src,
      title: it.title,
      alt: it.alt || it.title || it.name,
    }));
  }, []);

  return (
    <>
      <Seo
        title="Book Covers - Skyline VFX"
        description="Book cover design gallery for Skyline VFX."
      />
      <div className="min-h-screen text-white">
        <Header />
        <main className="pt-8 pb-20 px-6 lg:px-8">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10">
              <h1 className="text-4xl lg:text-5xl font-bold mb-4">Book Covers</h1>
              <p className="text-gray-300 text-lg max-w-3xl mx-auto">
                Full-cover designs with thumbnails for quick navigation.
              </p>
            </div>

            <BookCoverCarousel items={coverItems} />
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default BookCoverDesignPage;

